const types = [
  {
    title: "System Audit",
    mobile: true,
    desc: "Thorough system audit services to assess system integrity, ensure compliance, and identify opportunities for performance and security improvements.",
    speed: "Slow",
    icon: "/images/slider/sliderSales.png",
  },
  // {
  //   title: "Software Audit",
  //   mobile: true,
  //   desc: "Field and Back Office Sales Automation",
  //   speed: "Slow",
  //   icon: "/images/slider/sliderSales.png",
  // },
  {
    title: "Outlet Verification",
    mobile: true,
    desc: "Reliable outlet verification services to validate retail presence, ensure compliance with brand standards, and maintain accurate market data.",
    speed: "Slow",
    icon: "/images/slider/sliderSales.png",
  },
  {
    title: "Custom Software Development",
    mobile: true,
    desc: "Tailored custom software development services for mobile, web, and desktop applications—designed to meet your unique business needs with scalability and performance in mind.",
    speed: "Slow",
    icon: "/images/slider/sliderSales.png",
  },
  {
    title: "Payment Gateway",
    mobile: true,
    desc: "A secure and reliable payment gateway that seamlessly integrates with your in-house accounting system, ensuring smooth transactions and accurate financial tracking.",
    speed: "Slow",
    icon: "/images/Expertise/onlinepayment.jpg.avif",
  },
  {
    title: "3rd Party Integration",
    mobile: true,
    desc: "Seamless 3rd party integrations with services like weighbridges, MPesa, and more, to enhance your system’s functionality and streamline operations.",
    speed: "Slow",
    icon: "/images/Expertise/onlinepayment.jpg.avif",
  },
];

export function ServiceTypes() {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Services</h2>
      <div className="grid md:grid-cols-3 gap-4">
        {types.map((t, i) => (
          <div
            key={i}
            className="bg-white p-4 rounded-xl shadow hover:shadow-lg transition"
          >
            {/* <img
              src={t.icon}
              alt={t.title}
              className="w-200 h-20 mx-auto mb-4"
            /> */}
            <h3 className="text-lg font-bold">{t.title}</h3>
            <p className="text-sm text-gray-600">{t.desc}</p>
            {/* <p className="text-sm text-gray-400 mt-1">Delivery: {t.speed}</p> */}
          </div>
        ))}
      </div>
    </div>
  );
}
